import React from "react";
import { Component } from "react";

import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import DetailContainer from "../../../common/Layout/details/DetailsLayout.component";
import { Selected_Index } from '../../../../constants/external-constants';
import ArticleCatalogue from "./article-catalogue-table/article-catalogue-dashboard.component";
import ArticleUpload from "./article-upload/article-upload.component";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";

class ArticleLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: Selected_Index.i_Zero,
            contentIndex: Selected_Index.i_Zero
        }
    }

    handleSelectedIndex = (index) => {
        this.setState({ contentIndex: index })
    }
    render() {

        const { contentIndex } = this.state;

         let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingArticleCatalogueDashboardR])
         let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingArticleCatalogueDashboardRE])
         let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingArticleCatalogueDashboardRW])

        return (
            <div className="rate-card-container invoice-wrapper-container inventory-report-component" >
                <RequestHeaders headerTitle={'ArticleCatalogue'} />
                <div className="request-table data-table fit-width">
                    <DetailContainer
                        renderTabContent={this.handleSelectedIndex}
                        urlIndex={this.state.activeTab}
                        listTab={[
                            {
                                "id": Selected_Index.i_Zero,
                                "label": "Article List",
                                "hidden": false
                            },
                            {
                                "id": Selected_Index.i_One,
                                "label": "Article Upload",
                                "hidden": (isReadOnly || (!isReadAndExtractOnly && !isReadAndWrite)) ? true : false,
                                "disable": false
                            },

                        ]}
                    >

                        {contentIndex === Selected_Index.i_Zero && <ArticleCatalogue />}
                        {contentIndex === Selected_Index.i_One && <ArticleUpload/>}
                    </DetailContainer>
                </div>
            </div>
        )
    }
}

export default ArticleLayout;